import { API_METHODS } from './api.enums';
import { apiAction } from './utils.actions';

export type SearchCandidatesBody = {
    jobDescription: string
}

export type CandidateRecord = {
    userId: number,
    cvId: number,
    cvSummary?: string,
    firstName: string,
    similarity: number,
    locations?: string[],
    lastActivity: Date,
}

export const searchCandidatesAI = (
    payload: SearchCandidatesBody, backdrop = true,
) => apiAction<{ candidates: CandidateRecord[]}>({
    url: '/api/candidates/search',
    method: API_METHODS.POST,
    payload,
    backdrop,
});
